<template>
  <div class="asc-doc-mgmt-content-editor-wrapper">
    <asc-doc-mgmt-content-editor
      v-for="content in contents"
      :key="content.typeId"
      class="asc-doc-mgmt-content"
      :content="content"
      :user="user"
      :readonly="readonly"
      @onContentChangeCancel="handleContentChangeCancel"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import AscDocMgmtContentEditor from '@/components/molecules/AscDocMgmtContentEditor'

export default {
  name: 'AscDocMgmtContentEditorWrapper',

  components: {
    AscDocMgmtContentEditor,
  },

  props: {
    contents: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: true,
    },
    user: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    handleContentChangeCancel(content) {
      this.$emit('onContentChangeCancel', content)
    },
  },
}
</script>
